import React from "react";
import ReactDOM from "react-dom/client";
import { TablesChooserScreen } from "./screen";
import "../tailwind.css";
import { TablesChooserStore } from "@zebrabi/tables-chooser";
import { TablesChooserHostContext } from "@zebrabi/tables-chooser/host";
import type { TablesChooserHost } from "@zebrabi/tables-chooser/host";

const ROOT_ELEMENT_ID = "tables-chooser-react";

function addRootDOMElement() {
    document.body.querySelectorAll(`#${ROOT_ELEMENT_ID}`).forEach((element) => element.remove());
    const element = document.createElement("div");
    element.setAttribute("id", ROOT_ELEMENT_ID);
    document.body.prepend(element);
}

export function mountReactTablesChooser(host: TablesChooserHost, setVisible: boolean = false) {
    if (setVisible) {
        TablesChooserStore.set({
            isVisible: true,
            selectedTable: "",
        });
    }

    addRootDOMElement();
    const reactRoot = ReactDOM.createRoot(document.getElementById(ROOT_ELEMENT_ID) as HTMLElement);
    reactRoot.render(
        <React.StrictMode>
            <TablesChooserHostContext.Provider value={host}>
                <TablesChooserScreen />
            </TablesChooserHostContext.Provider>
        </React.StrictMode>
    );
}
